import React from 'react'

import classes from './AssessorGroupCollapse.scss'

import DataRow from './DataRow/DataRow'
import Collapse from '../../../../../UI/Collapse/Collapse'

import { IconButton } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

const assessorGroupCollapse = ({
  data,
  inputChanged,
  addRowClicked,
  deleteRowClicked,
  collapseClicked,
  dropdownOptions,
  currentCompany,
  currentEmp,
  edit
}) => {
  let rows = data.records.map((item, index) => {
    return (
      <DataRow
        key={index}
        inputChanged={(formKey, e) => inputChanged(data.groupId, index, formKey, e)}
        form={item}
        deleteRowClicked={() => deleteRowClicked(data.groupId, index)}
        dropdownOptions={dropdownOptions}
        currentCompany={currentCompany}
        currentEmp={currentEmp}
        // disabled={item.assessor_group_id.value === 1 && !edit}
      />
    )
  })
  return (
    <Collapse show={!data.collapsed} toggleBarClicked={collapseClicked} title={data.groupName}>
      <div className={classes.GroupWrapper}>
        {rows}
        <div className={classes.AddButtonWrapper}>
          <div className={classes.Button}>
            <IconButton
              // disabled={data.groupId === 1}
              color={'primary'}
              onClick={() => addRowClicked(data.groupId)}>
              <AddIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </Collapse>
  )
}

export default assessorGroupCollapse
